import React from "react";
import { Link } from "react-router-dom";
import "../styles/AccountDropdown.css";

const AccountDropdown = ({ handleLogout, user, isMobile = false }) => {

const getUserName = () => {
    if (!user) return 'Guest';

    // Try different possible name fields
    if (user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`;
    }
    if (user.name) {
      return user.name;
    }
    if (user.username) {
      return user.username;
    }
    return user.email || 'User';
  };


    return (
      <div className="account-dropdown">
        <div className="account-info">
          <p className="user-display-name">{getUserName()}</p>
        </div>

        <ul className="account-items-list">
          <li className="account-item">
            <Link to="/profile" className="dropdown-link">
              Uredi Profil
            </Link>
          </li>
          <li className="account-item">
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </li>
        </ul>
      </div>
    );
  };

export default AccountDropdown;